import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5be9e0f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stage" }
const _hoisted_2 = ["ratio"]
const _hoisted_3 = ["ratio"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "assets/stage/glow.png",
  class: "stage__image_glow",
  draggable: "false"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stage__cover" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: "assets/stage/bg.jpg",
      class: "stage__image",
      draggable: "false",
      ref: "stage",
      style: _normalizeStyle([{ left: _ctx.game.stage.left + 'px' }]),
      onLoadOnce: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imgLoaded && _ctx.imgLoaded(...args)))
    }, null, 36),
    _createElementVNode("div", {
      class: "stage_moonContainer",
      style: _normalizeStyle([
        { left: _ctx.game.stage.left + 'px' },
        { width: _ctx.game.stage.width + 'px' },
      ])
    }, [
      _createElementVNode("img", {
        src: "assets/stage/moon.svg",
        class: "stage__image_moon",
        draggable: "false",
        style: _normalizeStyle([
          { minWidth: 700 * _ctx.game.stage.ratio + 'px' },
          { top: 300 * _ctx.game.stage.ratio + 'px' },
        ]),
        ratio: _ctx.game.stage.ratio
      }, null, 12, _hoisted_2),
      _createElementVNode("div", {
        class: "moonshoot",
        style: _normalizeStyle([
          { minWidth: 564 * _ctx.game.stage.ratio + 'px' },
          { minHeight: 564 * _ctx.game.stage.ratio + 'px' },
          { top: 372 * _ctx.game.stage.ratio + 'px' },
        ])
      }, null, 4)
    ], 4),
    _createElementVNode("div", {
      class: "stage_moonContainer",
      style: _normalizeStyle([
        { left: _ctx.game.stage.left * 0.95 + 'px' },
        { width: _ctx.game.stage.width + 'px' },
      ])
    }, [
      _createElementVNode("img", {
        src: "assets/stage/clouds.svg",
        class: "stage__image_clouds",
        draggable: "false",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moonshot && _ctx.moonshot(...args))),
        style: _normalizeStyle([
          { minWidth: 5050 * _ctx.game.stage.ratio + 'px' },
          { top: 450 * _ctx.game.stage.ratio + 'px' },
        ]),
        ratio: _ctx.game.stage.ratio
      }, null, 12, _hoisted_3)
    ], 4),
    _createElementVNode("img", {
      src: "assets/stage/mountain_back.svg",
      class: "stage__image_mountain stage__image_mountain--back",
      draggable: "false",
      style: _normalizeStyle([
        { left: _ctx.game.stage.left * 0.9 + 'px' },
        { minWidth: _ctx.game.stage.width + 'px' },
      ])
    }, null, 4),
    _createElementVNode("img", {
      src: "assets/stage/mountain_front.svg",
      class: "stage__image_mountain stage__image_mountain--front",
      draggable: "false",
      style: _normalizeStyle([
        { left: _ctx.game.stage.left * 0.95 + 'px' },
        { minWidth: _ctx.game.stage.width + 'px' },
      ])
    }, null, 4),
    _createElementVNode("img", {
      src: "assets/stage/sea.svg",
      class: "stage__image_sea",
      draggable: "false",
      style: _normalizeStyle([
        { left: _ctx.game.stage.left + 'px' },
        { minWidth: _ctx.game.stage.width + 'px' },
      ])
    }, null, 4),
    _createElementVNode("div", {
      class: "stage_moonContainer",
      style: _normalizeStyle([
        { left: _ctx.game.stage.left + 'px' },
        { width: _ctx.game.stage.width + 'px' },
      ])
    }, _hoisted_5, 4),
    _hoisted_6
  ]))
}